import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import advertisingService from '../../services/advertisingService';

export const AdvertisingRouteLifecycle = () => {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  const pendingOldPath = useRef<string | null>(null);

  useEffect(() => {
    if (previousPath.current === pathname) {
      return;
    }

    pendingOldPath.current = pendingOldPath.current || previousPath.current;
    previousPath.current = pathname;
    const timeout = window.setTimeout(() => {
      const oldPath = pendingOldPath.current;
      pendingOldPath.current = null;
      if (oldPath && oldPath !== pathname) {
        advertisingService.onPageChanged(oldPath, pathname);
      }
    }, 0);

    return () => window.clearTimeout(timeout);
  }, [pathname]);

  return null;
};
